export const SECTIONS_REQUEST = 'sectionsRequest';
export const SECTIONS_LOADING = 'sectionsLoading';
export const SECTIONS_SUCCESS = 'sectionsSuccess';
export const SECTIONS_ERROR = 'sectionsError';
export const CALCULATE_PROGRESS = 'calculateProgress';
export const COMPLETE_HOME_SECTION = 'completeHomeSection';
export const COMPLETE_HOME_SECTION_SUCCESS = 'completeHomeSectionSuccess';
export const STATES_REQUEST = 'statesRequest';
export const STATES_SUCCESS = 'statesSuccess';
export const ZIP_CODES_REQUEST = 'zipCodesRequest';
export const ZIP_LOADING = 'ZipLoading';
export const ZIP_SUCCESS = 'ZipSuccess';
export const ZIP_ERROR = 'ZipError';
export const FETCH_APP_PRODUCTS = 'fetchAppProducts';
export const SET_APP_PRODUCTS = 'setAppProducts';
export const SET_IS_APP_ACCESS_PAID = 'setIsAppAccessPaid';
export const SET_IS_APP_CLOSED = 'setIsAppClosed';
export const SET_APP_ACCESS_TYPE = 'setAppAccessType';
export const FETCH_PAYMENT_TOKEN = 'fetchPaymentToken';
export const POST_PAYMENT_SUCCESS = 'postPaymentSuccess';
export const FETCH_ORDERS = 'fetchOrders';
export const SET_ORDERS = 'setOrders';
export const GET_FORM_PROGRESS = 'getFormProgress';
export const SET_PERSONAL_EDIT_LIMIT = 'setPersonalEditLimit';
export const SET_ADDRESS_EDIT_LIMIT = 'setAddressEditLimit';
export const FETCH_USER_APP = 'fetchUserApp';
export const USER_APP_ACCESS_ERROR = 'userAppAccessError';
export const USER_APP_ACCESS_SUCCESS = 'userAppAccessSuccess';
